import React from 'react';
import { CtaButton } from './CtaButton';
type SectionCtaProps = {
  label: string;
  lead?: string;
};
export function SectionCta({
  label,
  lead
}: SectionCtaProps) {
  return <div className="mt-12 flex flex-col items-center gap-4 sm:mt-14" data-id="element-280" data-mp="3idp30ve1msvh">
      {lead && <p className="max-w-xl text-center text-base font-semibold text-white sm:text-lg" data-id="element-281" data-mp="3ncjj3pkmm3bw">{lead}</p>}
      <CtaButton label={label} sub="Instant Digital Access • One-Time Payment • $27" data-id="element-282" data-mp="38nnbftmhesbt" />
    </div>;
}